const getThankYou = (state) => state.thankYouPage || {};

export const getShareSelector = (state) => getThankYou(state);
export const getCompanyNameSelector = (state) => getThankYou(state).companyName;
export const getCompanyUrlSelector = (state) => getThankYou(state).companyUrl;
export const getInvestorNameSelector = (state) => getThankYou(state).investorName;

export default getShareSelector;
